import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/medprev-web-app/medprev-web-app/packages/frontend/app/(main)/_components/not-found-state/not-found-state.tsx");
